import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lucky-spin-winner-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = { class: "winner-type-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "record-wrap" }
const _hoisted_9 = { class: "record-header flex" }
const _hoisted_10 = { class: "record-header-item" }
const _hoisted_11 = { class: "record-header-item" }
const _hoisted_12 = { class: "record-header-item" }
const _hoisted_13 = { class: "scroll-view" }
const _hoisted_14 = { class: "record-value" }
const _hoisted_15 = { class: "record-value" }
const _hoisted_16 = { class: "record-value" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "total-wrap flex justify-between" }

import { ref, watch, onMounted } from 'vue';
import { queryLuckySpinWinnerType, queryLuckySpinWinner } from '@/api';


export default {
  __name: 'WinnerRecord',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const winnerTypeList = ref([]);
const activeWinnerType = ref(null);
const dataList = ref([]);
const current = ref(1);
const pageSize = ref(50);
const totalCount = ref(0);

watch(activeWinnerType, (newValue, oldValue) => {
  if(newValue) {
    fetchList();
  }
})

onMounted(() => {
  fetchType();
})

const fetchType = () => {
  queryLuckySpinWinnerType().then(res => {
    winnerTypeList.value = res.data || [];
    activeWinnerType.value = winnerTypeList.value[0];
  });
}

const fetchList = () => {
  queryLuckySpinWinner({
    pageSize: pageSize.value,
    current: current.value,
    award: activeWinnerType.value ? activeWinnerType.value.value : null
  }).then(res => {
    dataList.value = res.data || [];
    totalCount.value = res.total;
  });
}

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      position: "center",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('luckySpin.winnerList').toUpperCase()), 1),
            _withDirectives(_createVNode(_component_van_icon, {
              class: "close-icon",
              name: "cross",
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 512), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winnerTypeList.value, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`type-item ${activeWinnerType.value && activeWinnerType.value.value === item.value ? 'active' : 'inactive'}`),
                  key: item.value,
                  onClick: $event => (activeWinnerType.value = item)
                }, [
                  _createElementVNode("div", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_7)), [
                  [_directive_audio]
                ])
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.time').toUpperCase()), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.player').toUpperCase()), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('label.reward').toUpperCase()), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                (dataList.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_van_list, {
                      key: 0,
                      class: "record-list"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "record-item flex",
                            key: item.id
                          }, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$moment(item.createTime * 1000).format('YYYY-MM-DD HH:mm:ss')), 1),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(item.username), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$filter.outputAmount(item.amount, 2)), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_van_empty, {
                        description: _ctx.$t('common.noData')
                      }, null, 8, ["description"])
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('luckySpin.recentWinner').format({ total: totalCount.value > pageSize.value ? pageSize.value : totalCount.value })), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('luckySpin.cumulativeWinner').format({ total: totalCount.value })), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}